export enum StatusProfile {
  STATUS_APPROVED = 'approved',
  STATUS_REPROVED = 'reproved',
}
